import { string, shape } from 'prop-types';

const lockShape = shape({
  initiatorName: string,
  endTime: string,
  loadId: string,
});

export default lockShape;
